/**
 * This middleware is used to logout user from webapp
 * in case any of the API request returns 401 (Unauthorized)
 * status code
 */

import { logout } from '../actions/users'

const logoutMiddleware = store => next => action => {
  try {
    if (action.type.endsWith('_REJECTED') && action.payload.response.status === 401 && action.type !== 'AUTHENTICATE_USER_REJECTED') {
      store.dispatch(logout())
    } else {
      next(action)
    }
  } catch (ignore) {
    next(action)
  }
}

export default logoutMiddleware
